import { render, staticRenderFns } from "./ChannelVideoCard.vue?vue&type=template&id=588b0098&scoped=true&lang=pug&"
import script from "./ChannelVideoCard.vue?vue&type=script&lang=js&"
export * from "./ChannelVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./ChannelVideoCard.vue?vue&type=style&index=0&id=588b0098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b0098",
  null
  
)

export default component.exports